/**
 * @prettier
 * @flow
 */
export function alertKnownErrorOrSomethingWentWrong(response: any): void {
    if (!response) {
        alert('Something went wrong');
        return;
    }
    if (response.data?.message) {
        alert(response.data.message);
    }
    alert(`Something went wrong (${response.status ?? ''}: ${response.problem ?? ''})`);
}
